import { render } from "./left.vue?vue&type=template&id=2b5dcafe&scoped=true&ts=true"
import script from "./left.vue?vue&type=script&lang=ts"
export * from "./left.vue?vue&type=script&lang=ts"

import "./left.vue?vue&type=style&index=0&id=2b5dcafe&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/mysystem_data_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5dcafe"]])

export default __exports__